import type { ListData } from '@openx/types/inventoryList';

export const getListData = (data?: string[]): ListData[] => {
  if (data?.length) {
    return data.map(item => ({ id: item, name: item, isOnList: true }));
  }

  return [];
};
